import {
  ProductsResultsSummary,
  useProducts,
} from '@airship-platform/airship-proposal';
import { FlexBox } from '@airship-platform/jam-web/components';
import React from 'react';
import EquipmentListView from './EquipmentListView';

const EquipmentList: React.FC = () => {
  const { products, updateProductsFilter, productsFilter, isLoading } =
    useProducts();

  return (
    <FlexBox flexDirection={'column'} gap={3}>
      <ProductsResultsSummary />
      {!isLoading && (
        <EquipmentListView
          products={products}
          pageSize={productsFilter.pageSize}
          onPageSizeChange={updateProductsFilter}
        />
      )}
    </FlexBox>
  );
};

export default EquipmentList;
